export default __webpack_public_path__ + "static/media/asset-1.d4057b39.svg";